import React from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
const SchoolParliament = () => {
  var myfun = function (ele) {
    let offsetTop = document.getElementById(ele).offsetTop;
    var right = document.getElementById("#right");
    window.scrollTo({
      top: offsetTop - 100,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Header />
      <div className="inner_slider">
        <LazyLoad>
          <img
            src="https://webapi.entab.info/api/image/SXSBPB/public/Images/inner_slider.jpg"
            className="img-fluid inner_slider_img"
            alt="St. Xaviers Bathinda"
          />
        </LazyLoad>
        <div className="row bread_cumb">
          <h2>School Parliament </h2>
          <div className="theme-heading">
            <span className="colorW marB10">
              <i className="bi bi-building"></i>
            </span>
          </div>
          <h5>
            <Link to="/">
              Home <i className="bi bi-arrow-right"></i>
            </Link>
            <span>
              Office Bearers <i className="bi bi-arrow-right"></i> School
              Parliament
            </span>
          </h5>
        </div>
      </div>
      <div className="innerpage">
        <div className="row inner_cont schoolparliament">
          <ul className="linktosec">
            <li>
              <button onClick={() => myfun("div2")}>Senior Cabinet</button>
            </li>
            <li>
              <button onClick={() => myfun("div8")}>Junior Cabinet</button>
            </li>
          </ul>
          <div className="col-lg-12 col-md-12 col-sm-12 col-12 cabintes_sec">
            <h2>Formal Address by Office Bearers</h2>
            <div id="right" className="right">
              <div className="sx_msg_sec" id="div2">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/PAVITKAURSIDHU-Prime Minister.jpg"
                          alt="St. Xavier’s School Bathinda"
                          className="sxumn_2021_msg img-fluid"
                        />
                      </LazyLoad>
                      <p>
                        “Excellence is not a skill, it is an attitude.” – Ralph
                        Marston
                      </p>
                      <p>“I slept and dreamt that life was joy. </p>
                      <p>I awoke and saw that life was duty. </p>
                      <p>
                        I acted, and behold, duty was joy.” – Rabindranath
                        Tagore
                      </p>
                      <p>
                        Leadership. The word itself carries a sense of
                        responsibility, pride and commitment. My heart fills
                        with gratitude at being given the esteemed privilege of
                        serving as the Prime Minister of an institution as
                        prestigious and visionary as St. Xavier’s School,
                        Bathinda. The day I took my oath, I made a silent vow in
                        my heart which I strive to fulfill everyday. This vow
                        denoted my promise to myself and the almighty that I
                        shall work relentlessly and tirelessly to not only
                        uphold the discipline and integrity of our great
                        institution but also to chase excellence in my every
                        endeavor as a leader and to make excellence the way of
                        life as well as the state of mind of every Xavierite. I
                        am a firm believer that it is hard work and consistence
                        that leads us to the pinnacle of success. St. Xavier’s
                        has consistently been a beacon of education, hope,
                        humanity and integrity. As a leader, I promise every
                        Xavierite to always serve with dedication, to lead by
                        example, to reflect my strength in my work and to let my
                        confidence fuel my and their determination. My message
                        to every member of the St.Xavier’s family shall be- St.
                        Xavier’s is not just a school we study in, it is a
                        legacy we carry. We are destined and shaped to be the
                        torch bearers of love, compassion and excellence in
                        society. As our school anthem suggests,
                      </p>
                      <p>“Fix your eyes Xavierites, on the star.”</p>
                      <p>
                        So, aim for the star and like it spread your love and
                        compassion as a guiding light for others. Last but not
                        the least, as the Prime Minister of our great
                        institution I shall like to state that I along with my
                        parliament promise to always protect and nurture the
                        flame of love and excellence and more importantly I vow
                        to lead with silent grace and to listen, reflect and be
                        a true representative of every Xavierite.
                      </p>
                      <p>
                        “The future belongs to those who believe in the beauty
                        of their dreams.May every step we take at St. Xavier’s
                        lead us toward greatness and service.”
                      </p>
                      <p>
                        <strong> PAVIT KAUR SIDHU </strong>
                      </p>
                      <p>
                        <strong> Prime Minister -11 D)</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/MayurGarg-deptyPrime Minister.jpg"
                          alt="St. Xavier’s School Bathinda"
                          className="sxumn_2021_msg img-fluid"
                        />
                      </LazyLoad>
                      <p>
                        <b>
                          “Leadership is not about being in charge. It is about
                          taking care of those in your charge.”
                        </b>
                      </p>
                      <p>
                        It is an immense pleasure and honor to serve as the
                        Deputy Prime Minister and to share this platform with
                        such dedicated and visionary individuals. Leadership is
                        not defined by authority or position—it is defined by
                        action, empathy, and the courage to make a difference.
                        Every great leader is first a great learner, someone who
                        listens, understands, and uplifts others.
                      </p>
                      <p>
                        As Deputy Prime Minister, I believe leadership is about
                        guiding with integrity, fostering teamwork, and ensuring
                        that every voice is heard. It is about creating an
                        environment where ideas can flourish, where every
                        challenge becomes an opportunity, and where
                        collaboration leads to meaningful change. Our collective
                        strength lies not in individual achievements, but in our
                        unity, purpose, and shared commitment toward progress.
                      </p>
                      <p>
                        Together, let us continue to move forward with
                        determination, vision, and humility—upholding the values
                        that form the foundation of true leadership. May we
                        always remember that leadership is a responsibility, not
                        a privilege, and that our greatest success lies in the
                        success of those we serve.
                      </p>
                      <p>
                        “Great leaders don’t create followers; they create more
                        leaders.”
                      </p>
                      <p>
                        <strong>Mayur Garg </strong>
                      </p>
                      <p>
                        <strong>(Deputy Prime Minister - XI B )</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>
                  <div className="col-lg-12col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Sargam Bansal-Head Girl.jpg"
                          alt="St. Xavier’s School Bathinda"
                          className="sxumn_2021_msg img-fluid"
                        />
                      </LazyLoad>
                      <p>
                        It is an honor to serve as the Head Girl of this
                        esteemed institution. I am sincerely grateful to our
                        Principal, faculty, and the school administration for
                        entrusting me with this responsibility. This role is
                        both a privilege and a commitment — a commitment to
                        uphold the values, standards, and ethos that define our
                        school.
                      </p>
                      <p>
                        Our school has always stood for academic excellence,
                        discipline, and holistic development. It has provided
                        each of us with an environment that encourages inquiry,
                        leadership, and character building. As Head Girl, I aim
                        to contribute meaningfully to this environment by
                        fostering cooperation, encouraging participation, and
                        ensuring that every student feels valued and heard.
                      </p>
                      <p>
                        My focus will be on leading by example — maintaining
                        integrity in conduct, consistency in effort, and respect
                        in all interactions. I believe that true leadership is
                        not about prominence, but about service: service to the
                        institution and to the student community.
                      </p>
                      <p>
                        I look forward to working collectively with my peers,
                        teachers, and student leaders to uphold the reputation
                        and legacy of our school. Together, we will continue to
                        strive for excellence, with clarity in purpose and
                        strength in unity.
                      </p>
                      <p>
                        <strong> Sargam Bansal </strong>
                      </p>
                      <p>
                        <strong>(Head Girl - 9th A )</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/MantajSinghSidhu- Head Boy.jpg"
                          alt="St. Xavier’s School Bathinda"
                          className="sxumn_2021_msg img-fluid"
                        />
                      </LazyLoad>
                      <p>
                        Pete Hoekstra once said, "Real leadership is leaders
                        recognizing that they serve the people they lead." This
                        philosophy will give guidance to my approach to
                        leadership.
                      </p>

                      <p>
                        It is a great honour and privilege to serve as the Head
                        Boy of our esteemed school. I am sincerely grateful to
                        our Father Principal, our dedicated teachers, and to my
                        fellow students for entrusting me with this
                        responsibility.
                      </p>
                      <p>
                        I pledge to carry out my duties with sincerity,
                        integrity, and a strong sense of responsibility. I aim
                        to be a voice for my peers and to uphold the values that
                        make our school a place of learning, respect, and unity.
                      </p>
                      <p>
                        Together, let us live by our school’s motto — “Learning
                        Hearts and Daring Minds.” May we continue to nurture
                        empathy, courage, and curiosity in all that we do. I
                        believe that true leadership lies in uplifting others
                        and creating an environment where everyone feels valued,
                        heard, and encouraged to achieve their best.
                      </p>
                      <p>
                        As we move forward, let us embrace every opportunity to
                        learn, grow, and make a positive difference in our
                        school community. I am confident that, with teamwork and
                        determination, we can make this year one filled with
                        meaningful achievements and lasting memories.
                      </p>
                      <p>
                        <strong>Mantaj Singh Sidhu </strong>
                      </p>
                      <p>
                        <strong>(Head Boy - IX C)</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>
                </div>
                <div className="clr"></div>
              </div>
              <div className="cabi_2022 clr_1_cabi">
                <center>
                  <h2>Core Parliament </h2>
                </center>
                <div className="row">
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/PAVIT KAUR SIDHU PRIME MINISTER.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>PRIME MINISTER </h3>
                      <h4>PAVIT KAUR SIDHU </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/MAYUR GARG Deputy Prime Minister.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY PRIME MINISTER </h3>
                      <h4>MAYUR GARG </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/KASHISH DEEP - Speaker.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>SPEAKER </h3>
                      <h4>KASHISH DEEP </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SANCHITA GOYAL- Deputy Speaker.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY SPEAKER </h3>
                      <h4>SANCHITA GOYAL </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/BINANTJOT KAUR GREWAL- CHIEF ADVISOR.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>CHIEF ADVISOR </h3>
                      <h4>BINANTJOT KAUR GREWAL </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/HAZEL PURI-CABINET SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>CABINET SECRETARY </h3>
                      <h4>HAZEL PURI </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/RAAVI SHARMA  CHIEF SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>CHIEF SECRETARY </h3>
                      <h4>RAAVI SHARMA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/MANINDER KAUR  GENERAL SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>GENERAL SECRETARY </h3>
                      <h4>MANINDER KAUR </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/KASHVI GOYAL SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> SECRETARY </h3>
                      <h4>KASHVI GOYAL </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/RIDHAMREET KAUR SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> SECRETARY </h3>
                      <h4>RIDHAMREET KAUR </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SADHIL BAJAJ SECRETARY.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> SECRETARY </h3>
                      <h4>SADHIL BAJAJ </h4>
                    </article>
                  </div>
                </div>
              </div>
              {/* <div className="cabi_2022 clr_2_cabi">
   <center><h2>Editorial Board</h2></center>
   <div className="row">
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
           <LazyLoad><img src="https://webapi.entab.info/api/image/SXSBPB/public/Images/1.Namika - XI C - Editor (Hindi).JPG"  alt="St. Xavies Bathinda" /></LazyLoad><h3>EDITORIAL BOARD (Hindi) </h3><h4>Namika - XI C </h4>
       </article>
   </div>
   <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
       <article>
       <LazyLoad>    <img src="https://webapi.entab.info/api/image/SXSBPB/public/Images/2.Taranjot Kaur - XI D - Editor (Punjabi).JPG"  alt="St. Xavies Bathinda" /></LazyLoad><h3>EDITORIAL BOARD (Punjabi) </h3><h4>Taranjot Kaur - XI D </h4>
       </article>
   </div> 
   </div>
   </div> */}
              <div className="cabi_2022 clr_3_cabi">
                <center>
                  <h2>School Parliament</h2>
                </center>
                <div className="row">
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Manya- Head Girl.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>HEAD GIRL </h3>
                      <h4> MANYA</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/MANTAJ SINGH- Head Boy.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>HEAD BOY</h3>
                      <h4>MANTAJ SINGH </h4>
                    </article>
                  </div>

                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/AARAV JAIN Ministry of External Affairs.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINSTER OF EXTERNAL AFFAIRS</h3>
                      <h4>AARAV JAIN </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/DHRITI SONI Minister of External Affairs.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF EXTERNAL AFFAIRS</h3>
                      <h4>DHRITI SONI </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/KANISHKA Minister of Social Welfare.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF SOCIAL WELFARE</h3>
                      <h4>KANISHKA</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/VALLPRABHA Deputy Minister of Social Welfare.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF SOCIAL WELFARE</h3>
                      <h4>VALLPRABHA</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/TOSHANIA - Minister of S.I.G.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> MINISTER OF SI.G</h3>
                      <h4>TOSHANIA</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/ANGADVEER SHARMA- Deputy Minister of S.I.G.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF S.I.G </h3>
                      <h4>ANGADVEER SHARMA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/HARSAHIB SINGH- Minister of Sports.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF SPORTS</h3>
                      <h4>HARSAHIB SINGH </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/GURSHEEN KAUR- Deputy Minister of Sports.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF SPORTS </h3>
                      <h4>GURSHEEN KAUR </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/HIMANSHU GARG- Ministry of I.T (Secretary).JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTRY OF IT </h3>
                      <h4>HIMANSHU GARG</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/CHAHAT GOYAL- Ministry of I.T (Member).JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTRY OF IT </h3>
                      <h4>CHAHAT GOYAL </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/AGAAZPREET KAUR- Minister of Environment.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF ENVIRONMENT </h3>
                      <h4>AGAAZPREET KAUR</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/NAVIKA BANSAL- Deputy Minister of Education.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> DEPUTY MINISTER OF ENVIRONMENT </h3>
                      <h4>NAVIKA BANSAL </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Delisha- Minister of Education.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF EDUCATION </h3>
                      <h4>Delisha</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SAMIKSHA - Deputy Minister of Education.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF EDUCATION</h3>
                      <h4>SAMIKSHA</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/NISHAD - Ministry of Finance.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTRY OF FINANCE </h3>
                      <h4>NISHAD </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/RADHIKA - Ministry of Finance .JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTRY OF FINANCE </h3>
                      <h4>RADHIKA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/IBAN SHARMA - Minister of Cultural Affairs.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3> MINISTER OF CULTURAL AFFAIRS </h3>
                      <h4>IBAN SHARMA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/PRABHSEES KAUR - Deputy Minister of Cultural Affairs.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF CULTURAL AFFAIRS </h3>
                      <h4>PRABHSEES KAUR </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/VIRAT GURANI - Ministry of HOME AFFAIRS.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF HOME AFFAIRS</h3>
                      <h4>VIRAT GURANI </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/PAREEN - Minster of Home Affairs.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF HOME AFFAIRS</h3>
                      <h4>PAREEN</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SAANVI - Ministry of Finance (Member).JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF HEALTH WELLNESS</h3>
                      <h4>SAANVI </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/VAGEESHA - Minister of Health.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF HEALTH WELLNESS</h3>
                      <h4>VAGEESHA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/YAMINI - Ministry of I.T (Member).JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>MINISTER OF INNOVATION AI </h3>
                      <h4>YAMINI</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/HARSHITA - Minister of Innovation.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>DEPUTY MINISTER OF INNOVATION AI </h3>
                      <h4>HARSHITA</h4>
                    </article>
                  </div>
                </div>
              </div>
              <div className="cabi_2022 clr_5_cabi">
                <center>
                  <h2>House Cabinet</h2>
                </center>
                <div className="row">
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/ISHPREETEMERALD.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>EMERALD HOUSE CAPTAIN </h3>
                      <h4>ISHPREET </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/FLORENCE PETERRuby House Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>RUBY HOUSE CAPTAIN </h3>
                      <h4>FLORENCE PETER</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/HARKIRAT KAURSapphire House Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>SAPPHIRE HOUSE CAPTAIN </h3>
                      <h4>HARKIRAT KAUR </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/INAYATTopaz House Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>TOPAZ HOUSE CAPTAIN </h3>
                      <h4>INAYAT</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/RUPANSHIEmerald House Vice Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>EMERALD HOUSE VICE CAPTAIN </h3>
                      <h4>RUPANSHI</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SHIVAANG BANSALRuby House Vice Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>RUBY HOUSE VICE CAPTAIN </h3>
                      <h4>SHIVAANG BANSAL</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/NAVYA SHARMASapphire House Vice Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>SAPPHIRE HOUSE VICE CAPTAIN </h3>
                      <h4>NAVYA SHARMA </h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <LazyLoad>
                        <img
                          src="https://webapi.entab.info/api/image/SXSBPB/public/Images/SMAIERA VALECHATopaz House Vice Captain.JPG"
                          alt="St. Xavies Bathinda"
                        />
                      </LazyLoad>
                      <h3>TOPAZ HOUSE VICE CAPTAIN </h3>
                      <h4> SMAIERA VALECHA</h4>
                    </article>
                  </div>
                </div>
              </div>

              <div className="cabi_2022 clr_5_cabi" id="div8">
                <center>
                  <h2>Junior School Cabinet</h2>
                </center>

                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Atharv_Sharma_Junior_Head_boy.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                      <h3>Message By Head Boy</h3>
                      <p>
                        It’s an honour to serve as the Head Boy of this esteemed
                        institution. I pledge to uphold the school’s values,
                        lead by example, and inspire my peers to strive for
                        excellence.
                      </p>
                      <p>
                        <strong>Atharv Sharma - III-E</strong>
                      </p>
                      <p>
                        <strong>Junior Head Boy</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>

                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Avneet_Kaur_Junior_Head_Girl.JPG"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                      <h3>Message By Head Girl</h3>
                      <p>
                        As Head Girl, I wish to be a voice of encouragement and
                        an example of perseverance, guiding my peers to dream
                        big and achieve more. I promise to do my best, lead with
                        kindness, and make our school proud.
                      </p>
                      <p>
                        <strong>Avneet Kaur - III-E</strong>
                      </p>
                      <p>
                        <strong>Junior Head Girl</strong>
                      </p>
                      <div className="clr"></div>
                    </article>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xxl-3 col-lg-1 col-md-1 col-sm-12 col-12 fullwidth550"></div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Atharv_Sharma_Junior_Head_boy.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Junior Head Boy</h3>
                      <h4>Atharv Sharma III-E</h4>
                    </article>
                  </div>

                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Avneet_Kaur_Junior_Head_Girl.JPG"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Junior Head Girl</h3>
                      <h4>Avneet Kaur - III E</h4>
                    </article>
                  </div>
<div className="col-xxl-3 col-lg-1 col-md-1 col-sm-12 col-12 fullwidth550"></div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Khushi_Mattu_Captain-Emerald_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Captain - Emerald House</h3>
                      <h4>Khushi Mattu - III E</h4>
                    </article>
                  </div>
       <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Hasnat_Kaur_Captain-Ruby_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Captain - Ruby House</h3>
                      <h4>Hasnat Kaur - III E</h4>
                    </article>
                  </div>
                        <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Jaivinjot singh_Captain-Sapphire_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Captain - Sapphire House</h3>
                      <h4>Jaivinjot Singh - III B</h4>
                    </article>
                  </div>
               <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Navroz_Kaur_Captain-Topaz_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Captain - Topaz House</h3>
                      <h4>Navroz Kaur - III B</h4>
                    </article>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Yashvi_Goyal_Vice-Captain-Emerald_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Vice Captain - Emerald House</h3>
                      <h4>Yashvi Goyal - III D</h4>
                    </article>
                  </div>          

                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Samarth_Bansal_Vice-Captain-Ruby_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Vice Captain - Ruby House</h3>
                      <h4>Samarth Bansal - III E</h4>
                    </article>
                  </div>            

                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Smaira_Sharma_Vice_Captain-Sapphire_House.JPG"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Vice Captain - Sapphire House</h3>
                      <h4>Samaira Sharma - III C</h4>
                    </article>
                  </div>

   

                  <div className="col-xxl-3 col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <img
                        src="https://webapi.entab.info/api/image/SXSBPB/public/Images/Ahamjot_Singh_Vice_captain-Topaz_House.jpg"
                        alt="St. Xavier’s Bathinda"
                      />
                      <h3>Vice Captain - Topaz House</h3>
                      <h4>Ahamjot Singh - III A</h4>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SchoolParliament;
